
import './App.css';
import Footer from './components/Footer';
import GalleryGrid from './components/GalleryGrid';
import Header from './components/Header';
import './main.scss';

function App() {
  return (
    <div className='app'>
      <Header />
      <GalleryGrid />
      <Footer />
    </div>
  );
}

export default App;
